import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchManagedUsers,
  resetUserPassword,
  registerUser,
} from "../api/admin";
import ManagedBloodPressureTable from "../components/ManagedBloodPressureTable";
import ManagedSugarTable from "../components/ManagedSugarTable";
import ManagedWeightTable from "../components/ManagedWeightTable";
import ManagedWaistTable from "../components/ManagedWaistTable";
import AdminWaistModal from "../components/AdminWaistModal";
import ManagedProfileTable from "../components/ManagedProfileTable";
import ResetPasswordModal from "../components/ResetPasswordModal";
import AdminAddBloodPressureModal from "../components/AdminAddBloodPressureModal";
import AdminBloodPressureHistory from "../components/AdminBloodPressureHistory";
import AdminAddBloodSugarModal from "../components/AdminAddBloodSugarModal";
import AdminBloodSugarHistory from "../components/AdminBloodSugarHistory";
import AdminAddWeightModal from "../components/AdminAddWeightModal";
import AdminWeightHistory from "../components/AdminWeightHistory";
import AdminAddUserModal from "../components/AdminAddUserModal";
import AdminDelUserModal from "../components/AdminDelUserModal";

function AdminDashboard() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [tab, setTab] = useState("blood");
  const [users, setUsers] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userName, setUserName] = useState("訪客");

  const loadUsers = async () => {
    const data = await fetchManagedUsers(token);
    setUsers(data);
  };

  useEffect(() => {
    document.title = "管理者後台";

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user?.name) {
        setUserName(user.name);
      }
    } catch (err) {
      console.error("讀取 user 發生錯誤", err);
    }
    loadUsers();
  }, []);

  const handleOpenModal = (mode, user) => {
    setSelectedUser(user);
    setModalMode(mode);
    setModalOpen(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>管理者後台 - {userName}您好</h3>
        <button className="btn btn-outline-danger btn-sm" onClick={handleLogout}>
          登出
        </button>
      </div>

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item"><button className={`nav-link ${tab === "waist" ? "active" : ""}`} onClick={() => setTab("waist")}>腰圍</button></li>
        <li className="nav-item">
          <button className={`nav-link ${tab === "blood" ? "active" : ""}`} onClick={() => setTab("blood")}>血壓</button>
        </li>
        <li className="nav-item">
          <button className={`nav-link ${tab === "sugar" ? "active" : ""}`} onClick={() => setTab("sugar")}>血糖</button>
        </li>
        <li className="nav-item">
          <button className={`nav-link ${tab === "weight" ? "active" : ""}`} onClick={() => setTab("weight")}>體重</button>
        </li>
        <li className="nav-item">
          <button className={`nav-link ${tab === "profile" ? "active" : ""}`} onClick={() => setTab("profile")}>基本資料</button>
        </li>
      </ul>

      {tab === "blood" && (
        <ManagedBloodPressureTable users={users} onOpenModal={handleOpenModal} />
      )}
      {tab === "waist" && <ManagedWaistTable users={users} onOpenModal={handleOpenModal} />}
      {modalOpen && selectedUser && (modalMode === "waist" || modalMode === "waistHistory") && (
        <AdminWaistModal key={`${selectedUser.userId}-${modalMode}`} user={selectedUser} history={modalMode === "waistHistory"} onClose={() => setModalOpen(false)} onUpdated={loadUsers} />
      )}
      {tab === "sugar" && (
        <ManagedSugarTable users={users} onOpenModal={handleOpenModal} />
      )}
      {tab === "weight" && (
        <ManagedWeightTable users={users} onOpenModal={handleOpenModal} />
      )}
      {tab === "profile" && (
        <div>
          <div className="d-flex justify-content-end mb-2">
            <button className="btn btn-primary" onClick={() => handleOpenModal("register", null)}>新增使用者</button>
          </div>
          <ManagedProfileTable users={users} onOpenModal={handleOpenModal} />
        </div>
      )}

      {/* 血壓新增 */}
      {modalOpen && selectedUser && modalMode === "bloodPressure" && (
        <AdminAddBloodPressureModal
          open={modalOpen}
          user={selectedUser}
          onClose={() => setModalOpen(false)}
          onSuccess={loadUsers}
        />
      )}

      {/* 血壓歷史 */}
      {modalOpen && selectedUser && modalMode === "bloodPressureHistory" && (
        <AdminBloodPressureHistory
          open={modalOpen}
          user={selectedUser}
          onClose={() => setModalOpen(false)}
          onUpdated={loadUsers}
        />
      )}

      {/* 血糖新增 */}
      {modalOpen && selectedUser && modalMode === "bloodSugar" && (
        <AdminAddBloodSugarModal
          open={modalOpen}
          user={selectedUser}
          onClose={() => setModalOpen(false)}
          onSuccess={loadUsers}
        />
      )}

      {/* 血糖歷史 */}
      {modalOpen && selectedUser && modalMode === "bloodSugarHistory" && (
        <AdminBloodSugarHistory
          open={modalOpen}
          user={selectedUser}
          onClose={() => setModalOpen(false)}
          onUpdated={loadUsers}
        />
      )}

      {/* 體重新增 */}
      {modalOpen && selectedUser && modalMode === "weight" && (
        <AdminAddWeightModal
          open={modalOpen}
          user={selectedUser}
          onClose={() => setModalOpen(false)}
          onSuccess={loadUsers}
        />
      )}

      {/* 體重歷史 */}
      {modalOpen && selectedUser && modalMode === "weightHistory" && (
        <AdminWeightHistory
          open={modalOpen}
          user={selectedUser}
          onClose={() => setModalOpen(false)}
          onUpdated={loadUsers}
        />
      )}

      {/* 密碼重設 */}
      {modalOpen && selectedUser && modalMode === "password" && (
        <ResetPasswordModal
          open={modalOpen}
          user={selectedUser}
          onClose={() => setModalOpen(false)}
          onSubmit={async (userId, newPassword) => {
            await resetUserPassword(token, { userId, newPassword });
            await loadUsers();
            setModalOpen(false);
          }}
        />
      )}

      {/* 建立使用者 */}
      {modalOpen && modalMode === "register" && (
        <AdminAddUserModal
          open={true}
          onClose={() => setModalOpen(false)}
          onSuccess={async () => {
            await loadUsers();
            setModalOpen(false);
          }}
        />
      )}

      {/* 註銷使用者 */}
      {modalOpen && selectedUser && modalMode === "delete" && (
        <AdminDelUserModal
          open={modalOpen}
          user={selectedUser}
          onClose={() => setModalOpen(false)}
          onSuccess={async () => {
            await loadUsers();
            setModalOpen(false);
          }}
        />
      )}

    </div>
  );
}

export default AdminDashboard;
